import React from "react";
import {
  Box,
  Stack,
  Tabs,
  Tab,
  styled,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import {
  HelpOutline,
  History,
} from "@mui/icons-material";
import HistoryTab from "../HistoryTab/HistoryTab";
import "./VerticalTabs.scss";
import HelpComponent from "../HelpComponent/HelpComponent";

const StyledTab = styled(Tab)(({ theme, open }) => ({
  alignItems: "flex-start",
  borderColor: grey[300],
  minWidth: "65px",
  transition: "all 0.2s ease-in-out",
  "& p": {
    color: grey[600],
  },
  "& img": {
    marginLeft: "auto",
    marginRight: "auto",
  },
  "&.Mui-selected, &:hover": {
    borderRadius: "4px",
    ...(open && {
      backgroundColor: "none",
    }),
  },
}));
export default function VerticalTabs(props) {
    const { open, handleDrawerOpen } = props;
    const [value, setValue] = React.useState(0);
    const tabData = [
      {
        content: <HistoryTab />,
        icon: <History />,
        title: "History",
      },
      {
        content: <HelpComponent />,
        icon: <HelpOutline />,
        title: "Help",
      },
    ];
  return (
    <Stack
      direction="row-reverse"
      width="98%"
      className={open ? "tabStackOpen" : "tabStackClose"}
      sx={{ display: "-webkit-box" }}
    >
      <Tabs
        orientation="vertical"
        indicatorColor="white"
        value={value}
        onChange={(_event, newValue) => setValue(newValue)}
        className="vertTabs"
      >
        {tabData.map((tab, index) => (
          <StyledTab
            className="styledtab"
            onClick={handleDrawerOpen}
            key={index}
            label={
              <>
                {tab.icon}
                {/* {tab.title} */}
              </>
            }
          />
        ))}
      </Tabs>
      {open &&
        tabData.map((tab, index) => (
          <TabPanel key={index} value={value} index={index}>
            {tab.content}
          </TabPanel>
        ))}
    </Stack>
  );
}

const TabPanel = ({ children, value, index }) => {
  return (
    value === index && (
      <Box
        sx={{ width: "72%", marginLeft: "85px", marginBottom: '100px' }}
        className="tab-panel-content-box"
      >
        {children}
      </Box>
    )
  );
};
